// 정처기 실기 원서접수 안내 팝업 — 표시 기간/변형 판정의 단일 출처(JCG-2382).
// 사전입력 팝업을 본 원서접수 안내로 전환했으며, 표시 여부·변형은 클라이언트 시계가
// 아니라 서버 시각으로 판정한다(API 라우트에서 호출).
export const PRE_APPLICATION = {
  ENABLED: true,
  // 사전입력 팝업과 다른 dismiss 네임스페이스를 사용해 새 본 접수 안내가 가려지지 않게 한다.
  ROUND_KEY: "2026-3-practical-registration",
  // KST(+09:00) ISO — 서버에서 요청 시각과 비교해 표시 여부/변형을 판정
  // 26-3 실기 원서접수는 추석 연휴로 두 구간에 나뉘며, 기사 등급은 접수 초일
  // 9.21(월) 14:00부터 시작한다(큐넷 2026.9.8·9.17 공지).
  START: "2026-09-21T00:00:00+09:00", // 1차 접수 당일 사전 안내 시작
  REGISTRATION_START: "2026-09-21T14:00:00+09:00",
  PRIMARY_END: "2026-09-23T18:00:00+09:00",
  LAST_DAY_START: "2026-09-28T00:00:00+09:00", // 접수 재개 당일 사전 안내 시작
  ADDITIONAL_START: "2026-09-28T09:00:00+09:00",
  END: "2026-09-28T18:00:00+09:00",
  // 표시·이동용(클라이언트 렌더에서 사용)
  QNET_HREF: "https://www.q-net.or.kr/",
  GUIDE_HREF: "/exam-registration/jeongcheogi-application",
  ROUND_LABEL: "2026년 3회 실기",
  PRIMARY_PERIOD_LABEL: "9월 21일(월) 14:00 ~ 9월 23일(수) 18:00",
  SERVICE_PAUSE_LABEL: "9월 23일(수) 18:00 ~ 9월 28일(월) 08:59",
  RESUMED_PERIOD_LABEL: "9월 28일(월) 09:00 ~ 18:00",
} as const;

export type PreApplicationPhase =
  | "hidden"
  | "beforeOpen"
  | "open"
  | "additionalBeforeOpen"
  | "additionalOpen";

/**
 * 본 원서접수 팝업 표시 단계를 서버 시각(ms) 기준으로 판정한다.
 * 1차 접수 종료부터 추가 접수 당일 전까지는 서비스 중단 구간이므로 숨긴다.
 *
 * 클라이언트 시계에 의존하지 않도록 반드시 서버에서 호출한다.
 */
export function getPreApplicationPhase(nowMs: number): PreApplicationPhase {
  if (!PRE_APPLICATION.ENABLED) return "hidden";
  if (nowMs < Date.parse(PRE_APPLICATION.START)) return "hidden";
  if (nowMs >= Date.parse(PRE_APPLICATION.END)) return "hidden";
  if (nowMs < Date.parse(PRE_APPLICATION.REGISTRATION_START)) return "beforeOpen";
  if (nowMs < Date.parse(PRE_APPLICATION.PRIMARY_END)) return "open";
  if (nowMs < Date.parse(PRE_APPLICATION.LAST_DAY_START)) return "hidden";
  if (nowMs < Date.parse(PRE_APPLICATION.ADDITIONAL_START)) {
    return "additionalBeforeOpen";
  }
  return "additionalOpen";
}
